customerAccountButton.$inject = ["API_URL", "$rootScope", "$http", "$cookies", "$location"];
import 'bootstrap/js/dropdown';
angular.module('calendarApp').directive('customerAccountButton', customerAccountButton);

function customerAccountButton(API_URL, $rootScope, $http, $cookies, $location) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/customer-account-button.html',
    link: function link(scope, elem, attrs) {
      scope.charging = smooth.charging; // If the customer is logged in, check for any outstanding invoices.

      if (smooth.charging && $rootScope.customerInfo) {
        $http.get("".concat(API_URL, "/api/v1/calendar/membership/payments/unpaid-invoices")).then(function (_ref) {
          var response = _ref.data;

          if (!response.success) {
            // Not 100% what to do here...
            return console.error('Could not retrieve customer invoices');
          }

          $rootScope.outstandingInvoices = response.outstandingInvoices;
          scope.outstandingInvoices = $rootScope.outstandingInvoices;
          $rootScope.safeApply && $rootScope.safeApply();
        }).catch(function (err) {
          console.error("Error retrieving customer invoices: ".concat(err.message));
        });
      }

      scope.logOut = function () {
        // Delete jwt token from local storage and from cookie,
        // redirect to the login page.
        localStorage.removeItem('calendar-jwt-token');
        $cookies.remove('calendar-x-access-token');

        if (typeof $rootScope.customerInfo !== 'undefined') {
          delete $rootScope.customerInfo;
        }

        $location.path('/');
      };
    }
  };
}